import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const ComingSoonBadge = () => (
  <Badge variant={BadgeVariant.PRIMARY} size={BadgeSize.SM}>
    Coming soon
  </Badge>
);
